import { render, staticRenderFns } from "./SpotDetail.vue?vue&type=template&id=3fce2184&"
import script from "./SpotDetail.vue?vue&type=script&lang=js&"
export * from "./SpotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports